/* unplugin-vue-components disabled */import { render } from "./liveIcon.vue?vue&type=template&id=31af34d8&scoped=true"
import script from "./liveIcon.vue?vue&type=script&lang=js"
export * from "./liveIcon.vue?vue&type=script&lang=js"

import "./liveIcon.vue?vue&type=style&index=0&id=31af34d8&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户湖南中医药大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31af34d8"]])

export default __exports__